import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Google OAuth API Service
export const googleOAuthService = {
  // Start OAuth flow
  async startOAuth() {
    const response = await api.get('/google-oauth/authorize');
    return response.data;
  },

  // Check authentication status
  async getAuthStatus() {
    const response = await api.get('/google-oauth/auth-status');
    return response.data;
  },

  // List user's Google Sheets
  async getSheets() {
    const response = await api.get('/google-oauth/sheets');
    return response.data;
  },

  // Get sheet tabs/worksheets
  async getSheetTabs(sheetId) {
    const response = await api.get(`/google-oauth/sheets/${sheetId}/tabs`);
    return response.data;
  },

  // Get column headers from sheet
  async getSheetHeaders(sheetId, tabName) {
    const response = await api.get(`/google-oauth/sheets/${sheetId}/headers`, {
      params: { tab_name: tabName }
    });
    return response.data;
  },

  // Get current month headers for mapping
  async getCurrentMonthHeaders(sheetId) {
    const response = await api.get(`/google-oauth/sheets/${sheetId}/current-month-headers`);
    return response.data;
  },

  // Get headers from all tabs for OTDR mapping
  async getAllTabsHeaders(sheetId) {
    const response = await api.get(`/google-oauth/sheets/${sheetId}/all-tabs-headers`);
    return response.data;
  },

  // Extract AWB data from all monthly tabs
  async extractAwbData(sheetId, configData) {
    const response = await api.post(`/google-oauth/sheets/${sheetId}/extract-awb-data`, configData);
    return response.data;
  },

  // Extract OTDR data from all tabs
  async extractOtdrDataAllTabs(sheetId, configData) {
    const response = await api.post(`/google-oauth/sheets/${sheetId}/extract-otdr-data-all-tabs`, configData);
    return response.data;
  },

  // Logout from Google
  async logout() {
    const response = await api.delete('/google-oauth/logout');
    return response.data;
  }
};

export default googleOAuthService;